export const POLISH = {
  'Caption Styles': 'Style napisów',
  'Captions look like this': 'Napisy wyglądają tak',
  'Closed-Captions Off': 'Napisy wyłączone',
  'Closed-Captions On': 'Napisy włączone',
  'Display Background': 'Wyświetl tło',
  'Enter Fullscreen': 'Tryb pełnoekranowy',
  'Enter PiP': 'Włącz obraz w obrazie',
  'Exit Fullscreen': 'Wyłącz tryb pełnoekranowy',
  'Exit PiP': 'Wyłącz obraz w obrazie',
  'Google Cast': 'Google Cast',
  'Keyboard Animations': 'Animacje klawiatury',
  'Seek Backward': 'Przewiń do tyłu',
  'Seek Forward': 'Przewiń do przodu',
  'Skip To Live': 'Przejdź do transmisji na żywo',
  'Text Background': 'Tło tekstu',
  Accessibility: 'Dostępność',
  AirPlay: 'AirPlay',
  Announcements: 'Ogłoszenia',
  Audio: 'Dźwięk',
  Auto: 'Automatyczny',
  Boost: 'Wzmocnienie',
  Captions: 'Napisy',
  Chapters: 'Rozdziały',
  Color: 'Kolor',
  Connected: 'Połączono',
  Connecting: 'Łączenie',
  Continue: 'Kontynuuj',
  Default: 'Domyślne',
  Disabled: 'Wyłączone',
  Disconnected: 'Rozłączono',
  Download: 'Pobierz',
  Family: 'Rodzina',
  Font: 'Czcionka',
  Fullscreen: 'Pełny ekran',
  LIVE: 'NA ŻYWO',
  Loop: 'Zapętlenie',
  Mute: 'Wycisz',
  Normal: 'Normalny',
  Off: 'Wyłącz',
  Opacity: 'Przezroczystość',
  Pause: 'Pauza',
  PiP: 'Obraz w obrazie',
  Play: 'Odtwórz',
  Playback: 'Odtwarzanie',
  Quality: 'Jakość',
  Replay: 'Powtórz',
  Reset: 'Reset',
  Seek: 'Przewiń',
  Settings: 'Ustawienia',
  Shadow: 'Cień',
  Size: 'Rozmiar',
  Speed: 'Prędkość',
  Text: 'Tekst',
  Track: 'Ścieżka',
  Unmute: 'Włącz dźwięk',
  Volume: 'Głośność',
}
